// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"8175fd6e","308":"4577a9f2","376":"c65c4710","388":"590940ee","507":"dc5f3b09","688":"db1e0e98","731":"c324f8c7","732":"3aff64a4","750":"b5e3c29d","858":"e9d30352","871":"036e2d54"}[chunkId] + ".chunk.css";
};